export function toLocationHref(url) {
    var _a;
    if (!url)
        return '';
    if (typeof url === 'string')
        return url;
    const pathname = (_a = url.pathname) !== null && _a !== void 0 ? _a : '';
    const rawSearch = typeof url.search === 'string' ? url.search : '';
    const rawHash = typeof url.hash === 'string' ? url.hash : '';
    const search = !rawSearch ? '' : (rawSearch.startsWith('?') ? rawSearch : `?${rawSearch}`);
    const hash = !rawHash ? '' : (rawHash.startsWith('#') ? rawHash : `#${rawHash}`);
    return `${pathname}${search}${hash}`;
}
